(function () {
  function syncRequired(picker) {
    var productId = picker.dataset.productId;
    var wrapper = document.querySelector('.wholesale-surtido-note[data-product-id="' + productId + '"]');
    if (!wrapper) return;
    var textarea = wrapper.querySelector('[data-surtido-note]');
    if (!textarea) return;
    var checked = picker.querySelector('input[type="radio"]:checked[data-surtido="true"]');
    if (checked) {
      if (!textarea.hasAttribute('required')) {
        textarea.setAttribute('required', 'required');
        textarea.setAttribute('aria-required', 'true');
      }
    } else if (textarea.hasAttribute('required')) {
      textarea.removeAttribute('required');
      textarea.removeAttribute('aria-required');
    }
  }

  function watch(picker) {
    if (picker.dataset.wholesaleSurtidoWatched === 'true') return;
    picker.dataset.wholesaleSurtidoWatched = 'true';
    syncRequired(picker);
    var observer = new MutationObserver(function () {
      syncRequired(picker);
    });
    observer.observe(picker, { childList: true, subtree: true, attributes: true });
  }

  function init() {
    document.querySelectorAll('variant-picker').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Watch for new variant-picker elements added to the page (e.g. quick-add dialogs).
  var bodyObserver = new MutationObserver(function () {
    document.querySelectorAll('variant-picker').forEach(watch);
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
